'use client';

import React from 'react';

export default function ContactSection() {
  return (
    <section
      id="contact"
      className="py-20 px-6"
      style={{ background: '#0B0B0F' }}
    >
      <div className="max-w-2xl mx-auto text-center">
        {/* Divider line */}
        <div
          className="w-16 h-px mx-auto mb-10"
          style={{ background: 'linear-gradient(90deg, transparent, #D4A843, transparent)' }}
        />

        <h2
          className="text-3xl md:text-4xl font-black tracking-[0.15em] uppercase mb-4"
          style={{ color: '#E8E4DC', fontFamily: 'Georgia, serif' }}
        >
          Get In Touch
        </h2>
        <p
          className="text-sm tracking-widest mb-12"
          style={{ color: 'rgba(232,228,220,0.45)' }}
        >
          Prefer a conversation? Reach out to your photographer directly.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12">
          {/* Phone */}
          <a
            href="tel:+15098684990"
            className="group flex flex-col items-center gap-3 transition-all duration-300"
          >
            <div
              className="w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110"
              style={{ border: '1px solid rgba(212,168,67,0.3)', background: 'rgba(212,168,67,0.05)' }}
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                className="w-5 h-5"
                style={{ color: '#D4A843' }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                />
              </svg>
            </div>
            <div>
              <p
                className="text-xs tracking-widest uppercase mb-1"
                style={{ color: 'rgba(232,228,220,0.35)' }}
              >
                Call Us
              </p>
              <p
                className="text-base font-semibold tracking-wide transition-colors duration-200 group-hover:text-yellow-400"
                style={{ color: '#E8E4DC' }}
              >
                (509) 868-4990
              </p>
            </div>
          </a>

          {/* Divider */}
          <div
            className="hidden sm:block w-px h-16"
            style={{ background: 'rgba(139,105,20,0.25)' }}
          />

          {/* Email */}
          <a
            href="mailto:Zach@regal-portraits.com"
            className="group flex flex-col items-center gap-3 transition-all duration-300"
          >
            <div
              className="w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110"
              style={{ border: '1px solid rgba(212,168,67,0.3)', background: 'rgba(212,168,67,0.05)' }}
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                className="w-5 h-5"
                style={{ color: '#D4A843' }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                />
              </svg>
            </div>
            <div>
              <p
                className="text-xs tracking-widest uppercase mb-1"
                style={{ color: 'rgba(232,228,220,0.35)' }}
              >
                Email Us
              </p>
              <p
                className="text-base font-semibold tracking-wide transition-colors duration-200 group-hover:text-yellow-400"
                style={{ color: '#E8E4DC' }}
              >
                Zach@regal-portraits.com
              </p>
            </div>
          </a>
        </div>

        {/* Bottom divider */}
        <div
          className="w-16 h-px mx-auto mt-12"
          style={{ background: 'linear-gradient(90deg, transparent, #D4A843, transparent)' }}
        />
      </div>
    </section>
  );
}
